// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Km9ve","content":"styles_content__TwMC5"};